import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NewsletterStrip from "../components/NewsletterStrip";
import { ArticleCard } from "../components/ContentCards";
import VideoBlogSection from "../components/VideoBlogSection";

export default function CategoryPage({ category, title }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/articles?category=${category}&status=published&limit=60`).then((r) => setItems(r.data.items)).finally(() => setLoading(false));
  }, [category]);

  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Header />
      <div className="container-page py-12 md:py-20">
        <div className="overline text-[#B4533C]">Section</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight mt-2 mb-4" data-testid="category-title">{title}</h1>
        <p className="text-[#4A4742] max-w-2xl">Practical, researched editorial from the JetsetLess desk.</p>
      </div>
      <div className="container-page pb-24">
        {loading ? (
          <div className="font-mono text-sm text-[#4A4742]">Loading…</div>
        ) : items.length === 0 ? (
          <div className="border border-dashed border-[#D6CFC4] p-12 text-center">
            <div className="font-serif text-2xl mb-2">No stories yet</div>
            <div className="text-sm text-[#4A4742]">The editors are working on it. Check back soon.</div>
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-10">
            {items.map((a) => <ArticleCard key={a.id} article={a} />)}
          </div>
        )}
      </div>
      <div className="container-page">
        <VideoBlogSection variant="inline" heading="From the video blog" />
      </div>
      <NewsletterStrip />
      <Footer />
    </div>
  );
}
